import FlightsSchedule from './FlightsSchedule';

export default FlightsSchedule;
